import { render, staticRenderFns } from "./ResetPasswordWithCode.vue?vue&type=template&id=6d594389&scoped=true&"
import script from "./ResetPasswordWithCode.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordWithCode.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordWithCode.vue?vue&type=style&index=0&id=6d594389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d594389",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDialog,VForm,VRow,VTextField})
